import { AwesomeEvent, ComponentAPI } from '@philips-emr/tws-core';
import Clickable, { ClickEventListener } from '@philips-emr/tws-core/lib/component/types/clickable';
import Hoverable, { HoverEventListener } from '@philips-emr/tws-core/lib/component/types/hoverable';

import { MenuOptionType } from './constants';

class MenuOptionAPI extends ComponentAPI implements Clickable, Hoverable {

  /** @event */
  @AwesomeEvent
  onClick =  new ClickEventListener();

  /** @event */
  @AwesomeEvent
  onDoubleClick = new ClickEventListener();

  /** @event */
  @AwesomeEvent
  onContextMenuClick = new ClickEventListener();

  /** @event */
  @AwesomeEvent
  onMouseEnter = new HoverEventListener();

  /** @event */
  @AwesomeEvent
  onMouseMove = new HoverEventListener();

  /** @event */
  @AwesomeEvent
  onMouseLeave = new HoverEventListener();

  setLabel(label: string): void {
    this.setState({ label });
  }

  getLabel(): string {
    return this.state.label;
  }

  setDescription(description: string): void {
    this.setState({ description });
  }

  getDescription(): string {
    return this.state.description;
  }

  setBadge(badge: string): void {
    this.setState({ badge });
  }

  getBadge(): string {
    return this.state.badge;
  }

  setRoute(route: string): void {
    this.setState({ route });
  }

  getRoute(): string {
    return this.state.route;
  }

  setIcon(icon: string): void {
    this.setState({ icon });
  }

  getIcon(): string {
    return this.state.icon;
  }

  setType(type: MenuOptionType): void {
    this.setState({ type });
  }

  getType(): MenuOptionType {
    return this.state.type;
  }

  setActive(active: boolean): void {
    this.setState({ active });
  }

  isActive(): boolean {
    return this.state.active;
  }

  isVisible(): boolean {
    return this.state.visible;
  }

  setVisible(visible: boolean): void {
    this.setState({ visible });
  }

}

export default MenuOptionAPI;
